import React from 'react'

function Icon({ fill = '#D16643' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="85"
      height="85"
      viewBox="0 0 85 85"
      fill="none"
    >
      <path
        fill={fill}
        d="M42.34 0a42.34 42.34 0 1042.34 42.34A42.38 42.38 0 0042.34 0zm0 82.15a39.82 39.82 0 1139.81-39.81 39.86 39.86 0 01-39.81 39.81zm22.28-65.09L52 29.66v-15.6a1.26 1.26 0 10-2.52 0v2.18c0 .18-.2 4-6.26 6.89V9.67a1.27 1.27 0 00-2.53 0v13.46c-6-2.87-6.25-6.69-6.26-6.89v-2.18a1.26 1.26 0 10-2.52 0v35.69L17.53 64.14a1.27 1.27 0 000 1.79c.238.234.557.366.89.37.334 0 .654-.134.89-.37L32.22 53c.61 2 2.55 5.52 8.48 8v12.35a1.27 1.27 0 002.53 0V61c8.65-3.58 8.77-9.36 8.77-9.61V33.23l14.4-14.39a1.26 1.26 0 000-1.78 1.24 1.24 0 00-1.78 0zM34.44 39.27A15.84 15.84 0 0039 42.66l-3.16 3.16a6.18 6.18 0 01-1.41-3.23l.01-3.32zm6.26 19c-6-2.86-6.25-6.68-6.26-6.89v-.58l1.41-1.4a18.91 18.91 0 004.85 2.83v6.04zm0-8.78a15.902 15.902 0 01-3.06-1.88l3.06-3.06v4.94zm0-8.79c-6-2.86-6.25-6.68-6.26-6.88v-3.33a17.111 17.111 0 006.26 4.17v6.04zm0-8.78c-6-2.86-6.25-6.68-6.26-6.89v-3.32a17.111 17.111 0 006.26 4.17v6.04zm8.79 19.46c0 .18-.2 4-6.26 6.89v-6a17.111 17.111 0 006.26-4.17v3.28zm0-8.78c0 .17-.2 4-6.26 6.89v-6a17 17 0 006.26-4.18v3.29zm0-10.4l-6.26 6.26v-3.8a17.111 17.111 0 006.26-4.17v1.71zm0-7.17c0 .18-.2 4-6.26 6.89v-6a17.111 17.111 0 006.26-4.17v3.28z"
      ></path>
    </svg>
  )
}

export default Icon
